import React from 'react';

import { Stack, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

interface IPackageSearchFiltersProps {
  search: string;
  description?: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
}

const PackageSearchFilters = ({ search, setSearch }: IPackageSearchFiltersProps): JSX.Element => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.currentTarget?.value || '';
    setSearch(value);
  };

  return (
    <Stack>
      <Text c='dimmed' fz='sm'>
        Browse by key words or categories to find specific packages…
      </Text>
      <TextInput
        placeholder='Search packages...'
        radius='md'
        size='md'
        icon={<IconSearch />}
        value={search}
        onChange={handleSearchChange}
        styles={theme => ({
          input: {
            backgroundColor: theme.white,
            borderColor: theme.colors.gray[3],
          },
        })}
      />
    </Stack>
  );
};

export default PackageSearchFilters;
